import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";
import { API } from "./constant";

export const costCenterApi = createApi({
  baseQuery,
  reducerPath: "costCenterApi",
  endpoints: (builder) => ({
    getAllCostCenterExpenses: builder.query({
      query: ({ ...values }) => ({
        url: API.COST_SERVICE_EXPENSES,
        params: { ...values },
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllCostCenterExpensesQuery } = costCenterApi;
